 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-06e1afd4":"2fdb6737","chunk-09ed1918":"0d5bb860","chunk-14e8beed":"d306dda9","chunk-16fc3399":"c021aca1","chunk-1c7eb328":"b445b3b5","chunk-20b874a9":"6f45ea14","chunk-2b8e8e3a":"38f8f9ea","chunk-2d0ab173":"a1921fe6","chunk-2d0b2186":"c899cbc4","chunk-2d0b32d8":"e44a9774","chunk-2d0c22e6":"b338108b","chunk-2d0c94cb":"6d55af77","chunk-2d0cf113":"6cb6d013","chunk-2d0e906b":"876ce41b","chunk-2d2086aa":"3c8c4d23","chunk-2d216626":"f5efa5b6","chunk-36a56e7a":"c17e14a7","chunk-36ab9263":"90decc34","chunk-b063d67a":"cae50507","chunk-4a764ccc":"e8d179ea","chunk-582b98f7":"7624c0f9","chunk-73b72180":"732ba505","chunk-1ea952b8":"f8d6ab9e","chunk-6f0c1278":"9bd479d7","chunk-047c53ed":"8d6c6a27","chunk-abce1db2":"08b89fab","chunk-2d21d7eb":"30aba4d4","chunk-2d21d8bc":"e2f8247e","chunk-2d231224":"0ed54c3a","chunk-3387a990":"eacaa6a3","chunk-3d4c64e9":"6703ce26","chunk-45f720b4":"cb01779b","chunk-067b54b4":"7cddcfba","chunk-2d0e1d96":"100cd4c7","chunk-aa4a7b42":"b3e1d0ec","chunk-4ab92aa2":"1c4e5239","chunk-4dd1088a":"162c7099","chunk-5964e8c4":"2fbc5c79","chunk-62137f86":"055e54ea","chunk-6d728209":"0375bf67","chunk-2d20ec90":"2603d782","chunk-75989b76":"a355d3f2","chunk-78cda9ac":"17cb9b47","chunk-7c78ab76":"f2374530","chunk-be479a08":"dcee4fe6","chunk-d9d4e8d2":"32afe332","chunk-f047ead8":"c2e6d16e","chunk-2d21b87b":"c2140bb2"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-14e8beed":1,"chunk-16fc3399":1,"chunk-1c7eb328":1,"chunk-20b874a9":1,"chunk-2b8e8e3a":1,"chunk-36ab9263":1,"chunk-b063d67a":1,"chunk-4a764ccc":1,"chunk-582b98f7":1,"chunk-73b72180":1,"chunk-1ea952b8":1,"chunk-6f0c1278":1,"chunk-047c53ed":1,"chunk-abce1db2":1,"chunk-3387a990":1,"chunk-3d4c64e9":1,"chunk-45f720b4":1,"chunk-4ab92aa2":1,"chunk-4dd1088a":1,"chunk-5964e8c4":1,"chunk-62137f86":1,"chunk-6d728209":1,"chunk-78cda9ac":1,"chunk-d9d4e8d2":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-06e1afd4":"31d6cfe0","chunk-09ed1918":"31d6cfe0","chunk-14e8beed":"e322ecba","chunk-16fc3399":"4a80fa86","chunk-1c7eb328":"cb85ac59","chunk-20b874a9":"e322ecba","chunk-2b8e8e3a":"e322ecba","chunk-2d0ab173":"31d6cfe0","chunk-2d0b2186":"31d6cfe0","chunk-2d0b32d8":"31d6cfe0","chunk-2d0c22e6":"31d6cfe0","chunk-2d0c94cb":"31d6cfe0","chunk-2d0cf113":"31d6cfe0","chunk-2d0e906b":"31d6cfe0","chunk-2d2086aa":"31d6cfe0","chunk-2d216626":"31d6cfe0","chunk-36a56e7a":"31d6cfe0","chunk-36ab9263":"247f079a","chunk-b063d67a":"3fa5c7f0","chunk-4a764ccc":"9ee9c42e","chunk-582b98f7":"ca3efb95","chunk-73b72180":"52479a70","chunk-1ea952b8":"444d76bc","chunk-6f0c1278":"7d2a767c","chunk-047c53ed":"2b5e8c76","chunk-abce1db2":"1c3d05bf","chunk-2d21d7eb":"31d6cfe0","chunk-2d21d8bc":"31d6cfe0","chunk-2d231224":"31d6cfe0","chunk-3387a990":"e322ecba","chunk-3d4c64e9":"76678a77","chunk-45f720b4":"e322ecba","chunk-067b54b4":"31d6cfe0","chunk-2d0e1d96":"31d6cfe0","chunk-aa4a7b42":"31d6cfe0","chunk-4ab92aa2":"21aa007e","chunk-4dd1088a":"e322ecba","chunk-5964e8c4":"e322ecba","chunk-62137f86":"e322ecba","chunk-6d728209":"e322ecba","chunk-2d20ec90":"31d6cfe0","chunk-75989b76":"31d6cfe0","chunk-78cda9ac":"56bc8f79","chunk-7c78ab76":"31d6cfe0","chunk-be479a08":"31d6cfe0","chunk-d9d4e8d2":"e322ecba","chunk-f047ead8":"31d6cfe0","chunk-2d21b87b":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://client-app.solidprofessor.com/blue/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
